// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-00c66b20]{border-bottom:1px solid var(--border);margin-bottom:0;padding-bottom:20px}.header H1[data-v-00c66b20]{flex:1}", ""]);
// Exports
module.exports = exports;
